export default __webpack_public_path__ + "static/media/arrowBgHover.a440e222.svg";